export const CURRENT_PAGE = "CURRENT_PAGE";
